/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum NuLinkboardAPILogicModelsJobSearchInteractionActionType {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum NuLinkboardAPILogicModelsIncludePersonalDetails {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum NuLinkboardAPILogicEnumsSortOrder {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum NuLinkboardAPILogicEnumsJobItemReadStatus {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum LinkboardDomainEnumsUserDisabilityPreference {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum LinkboardDomainEnumsProjectStatus {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum LinkboardDomainEnumsPerformerCategory {
  Value0 = 0,
  Value1 = 1,
  Value6 = 6,
  Value7 = 7,
  Value16 = 16,
  Value17 = 17,
  Value18 = 18,
  Value19 = 19,
  Value24 = 24,
  Value40 = 40,
}

/** @format int32 */
export enum LinkboardDomainEnumsLinkmailType {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum LinkboardDomainEnumsLinkmailStatus {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
}

/** @format int32 */
export enum LinkboardDomainEnumsJobItemType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum LinkboardDomainEnumsInternationalDistributionPartners {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
  Value10 = 10,
  Value11 = 11,
  Value12 = 12,
  Value13 = 13,
  Value14 = 14,
  Value15 = 15,
  Value16 = 16,
  Value17 = 17,
  Value18 = 18,
  Value19 = 19,
  Value20 = 20,
}

/** @format int32 */
export enum LinkboardDomainEnumsFollowUpStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum LinkboardDomainEnumsFollowUpIncludePersonalDetails {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum LinkboardDomainEnumsDisabilityPreference {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum LinkboardDomainEnumsCastingType {
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum LinkboardDomainEnumsAgentCategory {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value2147483647 = 2147483647,
}

export interface LinkboardDomainDocumentsAgencyPermission {
  /** @format int32 */
  agencyId?: number;
  allowNudge?: boolean;
  allowSelfSuggest?: boolean;
  performersReceiveBreakdownEmails?: boolean;
}

export interface MicrosoftAspNetCoreMvcProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface NuLinkboardAPILogicModelsAgencyModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export interface NuLinkboardAPILogicModelsAgentListDTOsAgentListInputModel {
  name?: string | null;
  agencies?: number[] | null;
}

export interface NuLinkboardAPILogicModelsAgentListModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
  comment?: string | null;
  /** @format date-time */
  created?: string | null;
  /** @format date-time */
  modified?: string | null;
  /** @format date-time */
  archived?: string | null;
  /** @format date-time */
  deleted?: string | null;
  isTemp?: boolean | null;
  agencies?: NuLinkboardAPILogicModelsAgencyModel[] | null;
}

export interface NuLinkboardAPILogicModelsAgentListsModel {
  /** @format int32 */
  id?: number;
  name?: string | null;
  /** @format date-time */
  modified?: string;
  /** @format int32 */
  agentsNumber?: number;
}

export interface NuLinkboardAPILogicModelsAgentSettingsModel {
  anyContractType?: boolean;
  contractTypes?: number[] | null;
  anyProductionType?: boolean;
  productionTypes?: number[] | null;
  anyProductionCountry?: boolean;
  productionCountries?: string[] | null;
  /** @format int32 */
  minPlayingAge?: number | null;
  /** @format int32 */
  maxPlayingAge?: number | null;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsBreakdownCastingLocationInputModel {
  id?: string | null;
  name?: string | null;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsBreakdownCloseInputModel {
  reason?: string | null;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsBreakdownCreateCopyInputModel {
  /** @format uuid */
  sourceId: string;
  type: LinkboardDomainEnumsLinkmailType;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsBreakdownCreateInputModel {
  castingLocation?: string | null;
  castingCountryCode?: string | null;
  castingLocationId?: string | null;
  castingLocations?:
    | NuLinkboardAPILogicModelsBreakdownDTOsBreakdownCastingLocationInputModel[]
    | null;
  castingTypes?: LinkboardDomainEnumsCastingType[] | null;
  castingTypeOtherDetails?: string | null;
  isLocalHire?: boolean;
  /** @format date-time */
  castingClosingDate: string;
  castingDetails?: string | null;
  /** @format uuid */
  concurrencyToken?: string;
  production: NuLinkboardAPILogicModelsBreakdownDTOsBreakdownProductionInputModel;
  /** @format uuid */
  projectId?: string;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsBreakdownDetailsInputModel {
  castingLocation?: string | null;
  castingCountryCode?: string | null;
  castingLocationId?: string | null;
  castingLocations?:
    | NuLinkboardAPILogicModelsBreakdownDTOsBreakdownCastingLocationInputModel[]
    | null;
  castingTypes?: LinkboardDomainEnumsCastingType[] | null;
  castingTypeOtherDetails?: string | null;
  isLocalHire?: boolean;
  /** @format date-time */
  castingClosingDate: string;
  castingDetails?: string | null;
  /** @format uuid */
  concurrencyToken?: string;
  production: NuLinkboardAPILogicModelsBreakdownDTOsBreakdownProductionInputModel;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsBreakdownLinkRoleInputModel {
  /** @format uuid */
  linkmailId?: string;
  /** @format uuid */
  roleId?: string;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsBreakdownLinkRolesInputModel {
  links: NuLinkboardAPILogicModelsBreakdownDTOsBreakdownLinkRoleInputModel[];
  /** @format uuid */
  concurrencyToken?: string;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsBreakdownProductionInputModel {
  /**
   * @minLength 1
   * @maxLength 100
   */
  title: string;
  /** @format int32 */
  typeId: number;
  summary?: string | null;
  dates?: string | null;
  location?: string | null;
  locationId?: string | null;
  countryCode?: string | null;
  director?: string | null;
  producer?: string | null;
  company?: string | null;
  /** @format int32 */
  contractTypeId: number;
  castingDirector?: string | null;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsBreakdownRoleInputModel {
  role: NuLinkboardAPILogicModelsBreakdownDTOsRoleInputModel;
  /** @format int32 */
  sequence?: number | null;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsBreakdownRolesInputModel {
  roles: NuLinkboardAPILogicModelsBreakdownDTOsBreakdownRoleInputModel[];
  /** @format uuid */
  concurrencyToken?: string;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsBreakdownSendInputModel {
  /** @format uuid */
  concurrencyToken?: string;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsBreakdownSendOptionsInputModel {
  agentCategories: LinkboardDomainEnumsAgentCategory[];
  performerCategories: LinkboardDomainEnumsPerformerCategory[];
  internationalDistributionPartners: LinkboardDomainEnumsInternationalDistributionPartners[];
  sendToFilmmakersPerformers?: boolean;
  message?: string | null;
  includePersonalDetailsToPerformers?: NuLinkboardAPILogicModelsIncludePersonalDetails;
  includePersonalDetailsToAgents?: NuLinkboardAPILogicModelsIncludePersonalDetails;
  spotlightExclusive?: boolean | null;
  /** @format uuid */
  concurrencyToken?: string;
  linkAttachments?: NuLinkboardAPILogicModelsLinkAttachmentModel[] | null;
  agentListIds?: number[] | null;
  recipientAgencies?: number[] | null;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsReportConcernInputModel {
  /** @format uuid */
  linkmailId?: string;
  /** @format uuid */
  roleId?: string;
  /**
   * @minLength 0
   * @maxLength 100
   */
  type: string;
  /**
   * @minLength 0
   * @maxLength 1000
   */
  details: string;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsRoleInputModel {
  /** @format uuid */
  id?: string;
  /** @minLength 1 */
  name: string;
  anyGender?: boolean;
  genderIds?: number[] | null;
  genderInfo?: string | null;
  anyAppearance?: boolean;
  appearanceIds?: number[] | null;
  disabilityPreference?: LinkboardDomainEnumsDisabilityPreference;
  disabilityIds?: number[] | null;
  disabilityInfo?: string | null;
  /** @format int32 */
  minimumPlayingAge?: number | null;
  /** @format int32 */
  maximumPlayingAge?: number | null;
  /** @format double */
  minimumHeight?: number | null;
  /** @format double */
  maximumHeight?: number | null;
  description?: string | null;
  /** @format int32 */
  contractTypeId?: number;
  contractTypeInfo?: string | null;
  agreementAccepted: boolean;
  earlyApply?: boolean | null;
  linkAttachments?: NuLinkboardAPILogicModelsLinkAttachmentModel[] | null;
  anyEthnicity?: boolean | null;
  heritageAndEthnicityIds?: number[] | null;
  ethnicBackgroundIds?: number[] | null;
  areAllEthnicityIdsRequired?: boolean | null;
}

export interface NuLinkboardAPILogicModelsBreakdownDTOsSetRoleCastInputModel {
  isCast?: boolean;
}

export interface NuLinkboardAPILogicModelsBreakdownListModel {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  projectId?: string;
  projectName?: string | null;
  title?: string | null;
  subject?: string | null;
  /** @format int32 */
  productionTypeId?: number;
  /** @format date-time */
  sent?: string | null;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  closingDate?: string | null;
  closedReason?: string | null;
  closedEarly?: boolean;
  /** @format date-time */
  originalClosingDate?: string | null;
  /** @format date-time */
  freezeDate?: string | null;
  status?: LinkboardDomainEnumsLinkmailStatus;
  /** @format int32 */
  rolesCount?: number;
  /** @format int64 */
  suggestionCount?: number;
  linkmailType?: LinkboardDomainEnumsLinkmailType;
  /** @format int32 */
  amendmentCount?: number;
  /** @format uuid */
  amendmentParentId?: string | null;
  hiddenBySpotlight?: boolean | null;
  agentListIds?: number[] | null;
  recipientAgencies?: number[] | null;
  agentCategories?: LinkboardDomainEnumsAgentCategory[] | null;
  performerCategories?: LinkboardDomainEnumsPerformerCategory[] | null;
  internationalDistributionPartners?:
    | LinkboardDomainEnumsInternationalDistributionPartners[]
    | null;
  sendToFilmmakersPerformers?: boolean;
  roles?: NuLinkboardAPILogicModelsBreakdownListRoleModel[] | null;
  isLocalHire?: boolean;
  productionLocationId?: string | null;
  productionLocation?: string | null;
}

export interface NuLinkboardAPILogicModelsBreakdownListRoleModel {
  /** @format uuid */
  id?: string;
  name?: string | null;
  /** @format int32 */
  sequence?: number;
  /** @format int64 */
  suggestionCount?: number;
}

export interface NuLinkboardAPILogicModelsBreakdownModel {
  /** @format uuid */
  id?: string;
  message?: string | null;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  sent?: string | null;
  subject?: string | null;
  castingTypes?: LinkboardDomainEnumsCastingType[] | null;
  castingLocation?: string | null;
  castingLocations?: NuLinkboardAPILogicModelsCastingLocationModel[] | null;
  castingTypeOtherDetails?: string | null;
  castingCountryCode?: string | null;
  castingLocationId?: string | null;
  isLocalHire?: boolean;
  /** @format date-time */
  castingClosingDate?: string | null;
  castingDetails?: string | null;
  spotlightExclusive?: boolean | null;
  agentCategories?: LinkboardDomainEnumsAgentCategory[] | null;
  performerCategories?: LinkboardDomainEnumsPerformerCategory[] | null;
  internationalDistributionPartners?:
    | LinkboardDomainEnumsInternationalDistributionPartners[]
    | null;
  sendToFilmmakersPerformers?: boolean;
  /** @format date-time */
  dateUpserted?: string;
  projectName?: string | null;
  /** @format uuid */
  projectId?: string;
  sentBy?: string | null;
  allowPublish?: boolean | null;
  includePersonalDetailsToPerformers?: NuLinkboardAPILogicModelsIncludePersonalDetails;
  includePersonalDetailsToAgents?: NuLinkboardAPILogicModelsIncludePersonalDetails;
  /** @format uuid */
  concurrencyToken?: string;
  /** @format int32 */
  amendmentCount?: number;
  /** @format uuid */
  amendmentParentId?: string | null;
  production?: NuLinkboardAPILogicModelsProductionModel;
  roles?: NuLinkboardAPILogicModelsBreakdownRoleModel[] | null;
  linkAttachments?: NuLinkboardAPILogicModelsLinkAttachmentModel[] | null;
  linkmailType?: LinkboardDomainEnumsLinkmailType;
  /** @format date-time */
  freezeDate?: string | null;
  agentListIds?: number[] | null;
  recipientAgencies?: number[] | null;
  hiddenBySpotlight?: boolean | null;
  performerCountryCodes?: string[] | null;
  status?: LinkboardDomainEnumsLinkmailStatus;
  closedEarly?: boolean;
  closedReason?: string | null;
  /** @format date-time */
  originalClosingDate?: string | null;
}

export interface NuLinkboardAPILogicModelsBreakdownRoleModel {
  role?: NuLinkboardAPILogicModelsRoleModel;
  /** @format int32 */
  sequence?: number;
}

export interface NuLinkboardAPILogicModelsBreakdownTreeInfoModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  created?: string;
  /** @format date-time */
  sent?: string | null;
  /** @format date-time */
  castingClosingDate?: string | null;
  castingDetails?: string | null;
  spotlightExclusive?: boolean | null;
  production?: NuLinkboardAPILogicModelsProductionModel;
}

export interface NuLinkboardAPILogicModelsCastingLocationModel {
  id?: string | null;
  name?: string | null;
}

export interface NuLinkboardAPILogicModelsFollowUpDTOsFollowUpCreateInputModel {
  /**
   * @minLength 1
   * @maxLength 100
   */
  subject: string;
  /**
   * @minLength 1
   * @maxLength 4000
   */
  body: string;
  includePersonalDetails: LinkboardDomainEnumsFollowUpIncludePersonalDetails;
}

export interface NuLinkboardAPILogicModelsFollowUpModel {
  /** @format uuid */
  id?: string;
  subject?: string | null;
  body?: string | null;
  includePersonalDetails?: LinkboardDomainEnumsFollowUpIncludePersonalDetails;
  /** @format date-time */
  created?: string;
  /** @format uuid */
  linkmailId?: string;
  /** @format int32 */
  productionTypeId?: number;
  productionTitle?: string | null;
  linkmailType?: LinkboardDomainEnumsLinkmailType;
  /** @format int32 */
  amendmentCount?: number;
  /** @format date-time */
  freezeDate?: string | null;
  /** @format date-time */
  linkmailSentDate?: string | null;
  sentBy?: string | null;
}

export interface NuLinkboardAPILogicModelsFollowUpRecipientModel {
  fullName?: string | null;
  agencyName?: string | null;
}

export interface NuLinkboardAPILogicModelsFollowUpRecipientPaginatedModel {
  items?: NuLinkboardAPILogicModelsFollowUpRecipientModel[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int64 */
  count?: number;
  internationalDistributionPartners?:
    | LinkboardDomainEnumsInternationalDistributionPartners[]
    | null;
}

export interface NuLinkboardAPILogicModelsJobModel {
  sender?: string | null;
  /** @format uuid */
  senderId?: string | null;
  title?: string | null;
  roleTitle?: string | null;
  /** @format int32 */
  productionTypeId?: number;
  /** @format int32 */
  contractTypeId?: number;
  /** @format int32 */
  amendmentCount?: number | null;
  /** @format date-time */
  sentDate?: string;
  /** @format date-time */
  closingDate?: string | null;
  closedReason?: string | null;
  closedEarly?: boolean;
  /** @format date-time */
  originalClosingDate?: string | null;
  type?: LinkboardDomainEnumsJobItemType;
  linkmailType?: LinkboardDomainEnumsLinkmailType;
  isRead?: boolean;
  isSuggested?: boolean;
  isNudged?: boolean;
  /** @format uuid */
  linkmailId?: string;
  /** @format uuid */
  roleId?: string | null;
  /** @format uuid */
  followUpId?: string | null;
  /** @format date-time */
  freezeDate?: string | null;
  isLocalHire?: boolean;
  productionLocationId?: string | null;
  productionLocation?: string | null;
  isCast?: boolean;
  anyEthnicity?: boolean | null;
  heritageAndEthnicityIds?: number[] | null;
  ethnicBackgroundIds?: number[] | null;
  areAllEthnicityIdsRequired?: boolean | null;
  isEarlyApply?: boolean;
  /** @format int32 */
  earlyApplyLimit?: number;
}

export interface NuLinkboardAPILogicModelsJobSearchInteraction {
  /** @minLength 1 */
  id: string;
  jobItemType?: LinkboardDomainEnumsJobItemType;
}

export interface NuLinkboardAPILogicModelsJobSearchJobSearchInputModel {
  textFilter?: string | null;
  /** @format uuid */
  senderId?: string | null;
  /** @format date-time */
  sentFrom?: string | null;
  /** @format date-time */
  sentTo?: string | null;
  /** @format date-time */
  closingDateFrom?: string | null;
  /** @format date-time */
  closingDateTo?: string | null;
  parentLinkmailOnly?: boolean;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  readStatus?: NuLinkboardAPILogicEnumsJobItemReadStatus;
  isSuggested?: boolean;
  hideClosed?: boolean;
  sort?: NuLinkboardAPILogicModelsSort;
  productionCountries?: string[] | null;
  productionTypes?: number[] | null;
  contractTypes?: number[] | null;
  /** @format int32 */
  minPlayingAge?: number | null;
  /** @format int32 */
  maxPlayingAge?: number | null;
  disabilityPreference?: LinkboardDomainEnumsUserDisabilityPreference;
  disabilityIds?: number[] | null;
  /** @format double */
  minimumHeight?: number | null;
  /** @format double */
  maximumHeight?: number | null;
  appearanceIds?: number[] | null;
  genderIds?: number[] | null;
  castingLocationIds?: string[] | null;
  productionLocationIds?: string[] | null;
  isLocalHire?: boolean;
  castingTypes?: LinkboardDomainEnumsCastingType[] | null;
  heritageAndEthnicityIds?: number[] | null;
  ethnicBackgroundIds?: number[] | null;
}

export interface NuLinkboardAPILogicModelsJobSearchUserInteractionInputModel {
  interactions: NuLinkboardAPILogicModelsJobSearchInteraction[];
  actionType?: NuLinkboardAPILogicModelsJobSearchInteractionActionType;
}

export interface NuLinkboardAPILogicModelsJobSettingsModel {
  agentSettings?: NuLinkboardAPILogicModelsAgentSettingsModel;
  performerSettings?: NuLinkboardAPILogicModelsPerformerSettingsModel;
}

export interface NuLinkboardAPILogicModelsLinkAttachmentModel {
  /** @format uuid */
  attachmentId: string;
  /** @minLength 1 */
  originalFileName: string;
  /** @format int32 */
  sequence: number;
  /** @minLength 1 */
  url: string;
}

export interface NuLinkboardAPILogicModelsLinkmailRelatedRolesModel {
  /** @format uuid */
  id?: string;
  title?: string | null;
  /** @format int32 */
  amendmentCount?: number | null;
  linkmailType?: LinkboardDomainEnumsLinkmailType;
  roles?: NuLinkboardAPILogicModelsRelatedRoleModel[] | null;
}

export interface NuLinkboardAPILogicModelsPaginatedModel1NuLinkboardAPILogicModelsAgencyModelNuLinkboardAPILogicVersion1000CultureNeutralPublicKeyTokenNull {
  items?: NuLinkboardAPILogicModelsAgencyModel[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int64 */
  count?: number;
}

export interface NuLinkboardAPILogicModelsPaginatedModel1NuLinkboardAPILogicModelsAgentListsModelNuLinkboardAPILogicVersion1000CultureNeutralPublicKeyTokenNull {
  items?: NuLinkboardAPILogicModelsAgentListsModel[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int64 */
  count?: number;
}

export interface NuLinkboardAPILogicModelsPaginatedModel1NuLinkboardAPILogicModelsBreakdownListModelNuLinkboardAPILogicVersion1000CultureNeutralPublicKeyTokenNull {
  items?: NuLinkboardAPILogicModelsBreakdownListModel[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int64 */
  count?: number;
}

export interface NuLinkboardAPILogicModelsPaginatedModel1NuLinkboardAPILogicModelsFollowUpModelNuLinkboardAPILogicVersion1000CultureNeutralPublicKeyTokenNull {
  items?: NuLinkboardAPILogicModelsFollowUpModel[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int64 */
  count?: number;
}

export interface NuLinkboardAPILogicModelsPaginatedModel1NuLinkboardAPILogicModelsJobModelNuLinkboardAPILogicVersion1000CultureNeutralPublicKeyTokenNull {
  items?: NuLinkboardAPILogicModelsJobModel[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int64 */
  count?: number;
}

export interface NuLinkboardAPILogicModelsPartnerJobModel {
  name?: string | null;
  sender?: string | null;
  /** @format date-time */
  sent?: string;
  /** @format date-time */
  closes?: string;
}

export interface NuLinkboardAPILogicModelsPerformerSettingsModel {
  anyContractType?: boolean;
  contractTypes?: number[] | null;
  anyProductionType?: boolean;
  productionTypes?: number[] | null;
  anyProductionCountry?: boolean;
  productionCountries?: string[] | null;
  /** @format int32 */
  minPlayingAge?: number | null;
  /** @format int32 */
  maxPlayingAge?: number | null;
  /** @format double */
  minimumHeight?: number | null;
  /** @format double */
  maximumHeight?: number | null;
  anyGender?: boolean;
  genderIds?: number[] | null;
  anyAppearance?: boolean;
  appearanceIds?: number[] | null;
  disabilityPreference?: LinkboardDomainEnumsUserDisabilityPreference;
  disabilityIds?: number[] | null;
  anyEthnicity?: boolean;
  heritageAndEthnicityIds?: number[] | null;
  ethnicBackgroundIds?: number[] | null;
}

export interface NuLinkboardAPILogicModelsProductionModel {
  title?: string | null;
  /** @format int32 */
  typeId?: number;
  summary?: string | null;
  dates?: string | null;
  location?: string | null;
  countryCode?: string | null;
  locationId?: string | null;
  director?: string | null;
  producer?: string | null;
  company?: string | null;
  /** @format int32 */
  contractTypeId?: number;
  castingDirector?: string | null;
  /** @format uuid */
  castingDirectorId?: string;
  /** @format date-time */
  created?: string | null;
  /** @format date-time */
  modified?: string | null;
  /** @format date-time */
  archived?: string | null;
  /** @format date-time */
  deleted?: string | null;
}

export interface NuLinkboardAPILogicModelsProjectModel {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /** @format date-time */
  dateUpserted?: string;
  /** @format uuid */
  id?: string;
  /** @format int64 */
  activeBreakdownCount?: number;
  /** @format int64 */
  totalBreakdownCount?: number;
  status?: LinkboardDomainEnumsProjectStatus;
}

export interface NuLinkboardAPILogicModelsRelatedRoleModel {
  /** @format uuid */
  id?: string;
  name?: string | null;
  isCast?: boolean | null;
}

export interface NuLinkboardAPILogicModelsRoleModel {
  /** @format uuid */
  id?: string;
  name?: string | null;
  anyGender?: boolean;
  genderIds?: number[] | null;
  genderInfo?: string | null;
  anyAppearance?: boolean;
  appearanceIds?: number[] | null;
  disabilityPreference?: LinkboardDomainEnumsDisabilityPreference;
  disabilityIds?: number[] | null;
  disabilityInfo?: string | null;
  /** @format int32 */
  minimumPlayingAge?: number | null;
  /** @format int32 */
  maximumPlayingAge?: number | null;
  /** @format double */
  minimumHeight?: number | null;
  /** @format double */
  maximumHeight?: number | null;
  description?: string | null;
  /** @format int32 */
  contractTypeId?: number;
  contractTypeInfo?: string | null;
  agreementAccepted?: boolean | null;
  linkAttachments?: NuLinkboardAPILogicModelsLinkAttachmentModel[] | null;
  isCast?: boolean | null;
  anyEthnicity?: boolean | null;
  heritageAndEthnicityIds?: number[] | null;
  ethnicBackgroundIds?: number[] | null;
  areAllEthnicityIdsRequired?: boolean | null;
  ethnicityLabel?: string | null;
  isEarlyApply?: boolean | null;
  /** @format int32 */
  earlyApplyLimit?: number | null;
}

export interface NuLinkboardAPILogicModelsSort {
  name?: string | null;
  order?: NuLinkboardAPILogicEnumsSortOrder;
}

export interface NuLinkboardAPILogicModelsWhoamiModel {
  /** @format uuid */
  userId?: string;
  userType?: string | null;
  username?: string | null;
  email?: string | null;
  forenames?: string | null;
  surname?: string | null;
  agencyPermissions?: LinkboardDomainDocumentsAgencyPermission[] | null;
  restrictAccess?: boolean | null;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title NuLinkboard API V1
 * @version v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  linkboard = {
    /**
     * No description
     *
     * @tags Agencies
     * @name AgenciesGet
     * @request GET:/linkboard/Agencies
     * @secure
     */
    agenciesGet: <
      TResponse = NuLinkboardAPILogicModelsPaginatedModel1NuLinkboardAPILogicModelsAgencyModelNuLinkboardAPILogicVersion1000CultureNeutralPublicKeyTokenNull,
      TError = any,
    >(
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        AgencyName?: string;
        Categories?: LinkboardDomainEnumsAgentCategory[];
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Agencies`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgentLists
     * @name AgentListsGet
     * @request GET:/linkboard/AgentLists/{id}
     * @secure
     */
    agentListsGet: <
      TResponse = NuLinkboardAPILogicModelsAgentListModel,
      TError = any,
    >(
      id: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/AgentLists/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgentLists
     * @name AgentListsUpdate
     * @request PUT:/linkboard/AgentLists/{id}
     * @secure
     */
    agentListsUpdate: <
      TResponse = NuLinkboardAPILogicModelsAgentListModel,
      TError = any,
    >(
      id: number,
      data: NuLinkboardAPILogicModelsAgentListDTOsAgentListInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/AgentLists/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgentLists
     * @name AgentListsGet2
     * @request GET:/linkboard/AgentLists
     * @originalName agentListsGet
     * @duplicate
     * @secure
     */
    agentListsGet2: <
      TResponse = NuLinkboardAPILogicModelsPaginatedModel1NuLinkboardAPILogicModelsAgentListsModelNuLinkboardAPILogicVersion1000CultureNeutralPublicKeyTokenNull,
      TError = any,
    >(
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        IsArchived?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/AgentLists`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgentLists
     * @name AgentListsCreate
     * @request POST:/linkboard/AgentLists
     * @secure
     */
    agentListsCreate: <
      TResponse = NuLinkboardAPILogicModelsAgentListModel,
      TError = any,
    >(
      data: NuLinkboardAPILogicModelsAgentListDTOsAgentListInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/AgentLists`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgentLists
     * @name AgentListsDelete
     * @request POST:/linkboard/AgentLists/delete
     * @secure
     */
    agentListsDelete: <TResponse = unknown, TError = any>(
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/AgentLists/delete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgentLists
     * @name AgentListsArchive
     * @request POST:/linkboard/AgentLists/archive
     * @secure
     */
    agentListsArchive: <TResponse = unknown, TError = any>(
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/AgentLists/archive`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgentLists
     * @name AgentListsRestore
     * @request POST:/linkboard/AgentLists/restore
     * @secure
     */
    agentListsRestore: <TResponse = unknown, TError = any>(
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/AgentLists/restore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AgentLists
     * @name AgentListsGetRange
     * @request POST:/linkboard/AgentLists/getrange
     * @secure
     */
    agentListsGetRange: <
      TResponse = NuLinkboardAPILogicModelsAgentListsModel[],
      TError = any,
    >(
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/AgentLists/getrange`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Attachments
     * @name AttachmentsCreate
     * @request POST:/linkboard/Attachments
     * @secure
     */
    attachmentsCreate: <TResponse = string, TError = any>(
      data: {
        /** @format binary */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Attachments`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Attachments
     * @name AttachmentsGet
     * @request GET:/linkboard/Attachments/{id}
     * @secure
     */
    attachmentsGet: <TResponse = unknown, TError = any>(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Attachments/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Attachments
     * @name AttachmentsDelete
     * @request DELETE:/linkboard/Attachments/{id}
     * @secure
     */
    attachmentsDelete: <TResponse = unknown, TError = any>(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Attachments/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsGet
     * @request GET:/linkboard/Breakdowns/{id}
     * @secure
     */
    breakdownsGet: <
      TResponse = NuLinkboardAPILogicModelsBreakdownModel,
      TError = any,
    >(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsGetRelated
     * @request GET:/linkboard/Breakdowns/{id}/getrelated
     * @secure
     */
    breakdownsGetRelated: <
      TResponse = NuLinkboardAPILogicModelsBreakdownTreeInfoModel[],
      TError = any,
    >(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/${id}/getrelated`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsGet2
     * @request GET:/linkboard/Breakdowns
     * @originalName breakdownsGet
     * @duplicate
     * @secure
     */
    breakdownsGet2: <
      TResponse = NuLinkboardAPILogicModelsPaginatedModel1NuLinkboardAPILogicModelsBreakdownListModelNuLinkboardAPILogicVersion1000CultureNeutralPublicKeyTokenNull,
      TError = any,
    >(
      query?: {
        /** @format uuid */
        ProjectId?: string;
        Statuses?: LinkboardDomainEnumsLinkmailStatus[];
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        /** @maxLength 150 */
        TitleFilter?: string;
        ShowClosed?: boolean;
        "Sort.Name"?: string;
        "Sort.Order"?: NuLinkboardAPILogicEnumsSortOrder;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsCreate
     * @request POST:/linkboard/Breakdowns
     * @secure
     */
    breakdownsCreate: <
      TResponse = NuLinkboardAPILogicModelsBreakdownModel,
      TError = any,
    >(
      data: NuLinkboardAPILogicModelsBreakdownDTOsBreakdownCreateInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsCreateCopy
     * @request POST:/linkboard/Breakdowns/createcopy
     * @secure
     */
    breakdownsCreateCopy: <
      TResponse = NuLinkboardAPILogicModelsBreakdownModel,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      data: NuLinkboardAPILogicModelsBreakdownDTOsBreakdownCreateCopyInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/createcopy`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsUpdateDetails
     * @request POST:/linkboard/Breakdowns/{id}/details
     * @secure
     */
    breakdownsUpdateDetails: <
      TResponse = NuLinkboardAPILogicModelsBreakdownModel,
      TError = any,
    >(
      id: string,
      data: NuLinkboardAPILogicModelsBreakdownDTOsBreakdownDetailsInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/${id}/details`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsLinkRoles
     * @request POST:/linkboard/Breakdowns/{id}/linkroles
     * @secure
     */
    breakdownsLinkRoles: <
      TResponse = NuLinkboardAPILogicModelsBreakdownModel,
      TError = any,
    >(
      id: string,
      data: NuLinkboardAPILogicModelsBreakdownDTOsBreakdownLinkRolesInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/${id}/linkroles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsUpdateRoles
     * @request POST:/linkboard/Breakdowns/{id}/roles
     * @secure
     */
    breakdownsUpdateRoles: <
      TResponse = NuLinkboardAPILogicModelsBreakdownModel,
      TError = any,
    >(
      id: string,
      data: NuLinkboardAPILogicModelsBreakdownDTOsBreakdownRolesInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/${id}/roles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsUpdateSendOptions
     * @request POST:/linkboard/Breakdowns/{id}/sendoptions
     * @secure
     */
    breakdownsUpdateSendOptions: <
      TResponse = NuLinkboardAPILogicModelsBreakdownModel,
      TError = any,
    >(
      id: string,
      data: NuLinkboardAPILogicModelsBreakdownDTOsBreakdownSendOptionsInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/${id}/sendoptions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsSendBreakdown
     * @request POST:/linkboard/Breakdowns/{id}/sendbreakdown
     * @secure
     */
    breakdownsSendBreakdown: <TResponse = unknown, TError = any>(
      id: string,
      data: NuLinkboardAPILogicModelsBreakdownDTOsBreakdownSendInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/${id}/sendbreakdown`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsClose
     * @request POST:/linkboard/Breakdowns/{id}/close
     * @secure
     */
    breakdownsClose: <TResponse = unknown, TError = any>(
      id: string,
      data: NuLinkboardAPILogicModelsBreakdownDTOsBreakdownCloseInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/${id}/close`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsArchive
     * @request POST:/linkboard/Breakdowns/archive
     * @secure
     */
    breakdownsArchive: <TResponse = unknown, TError = any>(
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/archive`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsRestore
     * @request POST:/linkboard/Breakdowns/restore
     * @secure
     */
    breakdownsRestore: <TResponse = unknown, TError = any>(
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/restore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsDelete
     * @request POST:/linkboard/Breakdowns/delete
     * @secure
     */
    breakdownsDelete: <TResponse = unknown, TError = any>(
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/delete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsGetRelatedRoles
     * @request GET:/linkboard/Breakdowns/{id}/getrelatedroles
     * @secure
     */
    breakdownsGetRelatedRoles: <
      TResponse = NuLinkboardAPILogicModelsLinkmailRelatedRolesModel[],
      TError = any,
    >(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/${id}/getrelatedroles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsSetRoleCast
     * @request PUT:/linkboard/Breakdowns/{linkmailId}/role/{roleId}/cast
     * @secure
     */
    breakdownsSetRoleCast: <
      TResponse = NuLinkboardAPILogicModelsBreakdownModel,
      TError = any,
    >(
      linkmailId: string,
      roleId: string,
      data: NuLinkboardAPILogicModelsBreakdownDTOsSetRoleCastInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/${linkmailId}/role/${roleId}/cast`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Breakdowns
     * @name BreakdownsSetAllRolesCast
     * @request PUT:/linkboard/Breakdowns/{linkmailId}/cast
     * @secure
     */
    breakdownsSetAllRolesCast: <
      TResponse = NuLinkboardAPILogicModelsBreakdownModel,
      TError = any,
    >(
      linkmailId: string,
      data: NuLinkboardAPILogicModelsBreakdownDTOsSetRoleCastInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Breakdowns/${linkmailId}/cast`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags External
     * @name ExternalGet
     * @request GET:/linkboard/External/breakdowns/{id}
     * @secure
     */
    externalGet: <
      TResponse = NuLinkboardAPILogicModelsBreakdownModel,
      TError = any,
    >(
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/External/breakdowns/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FollowUps
     * @name FollowUpsGet
     * @request GET:/linkboard/breakdowns/{linkmailId}/FollowUps/{id}
     * @secure
     */
    followUpsGet: <
      TResponse = NuLinkboardAPILogicModelsFollowUpModel,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      linkmailId: string,
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/breakdowns/${linkmailId}/FollowUps/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FollowUps
     * @name FollowUpsCreate
     * @request POST:/linkboard/breakdowns/{linkmailId}/FollowUps
     * @secure
     */
    followUpsCreate: <
      TResponse = NuLinkboardAPILogicModelsFollowUpModel,
      TError = MicrosoftAspNetCoreMvcProblemDetails,
    >(
      linkmailId: string,
      data: NuLinkboardAPILogicModelsFollowUpDTOsFollowUpCreateInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/breakdowns/${linkmailId}/FollowUps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FollowUps
     * @name FollowUpsGet2
     * @request GET:/linkboard/FollowUps
     * @originalName followUpsGet
     * @duplicate
     * @secure
     */
    followUpsGet2: <
      TResponse = NuLinkboardAPILogicModelsPaginatedModel1NuLinkboardAPILogicModelsFollowUpModelNuLinkboardAPILogicVersion1000CultureNeutralPublicKeyTokenNull,
      TError = any,
    >(
      query?: {
        /** @maxLength 150 */
        TextFilter?: string;
        Status?: LinkboardDomainEnumsFollowUpStatus;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/FollowUps`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FollowUps
     * @name FollowUpsGetRecipients
     * @request GET:/linkboard/breakdowns/{linkmailId}/FollowUps/{id}/recipients
     * @secure
     */
    followUpsGetRecipients: <
      TResponse = NuLinkboardAPILogicModelsFollowUpRecipientPaginatedModel,
      TError = any,
    >(
      linkmailId: string,
      id: string,
      query?: {
        /** @maxLength 150 */
        TextFilter?: string;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/breakdowns/${linkmailId}/FollowUps/${id}/recipients`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FollowUps
     * @name FollowUpsArchive
     * @request POST:/linkboard/FollowUps/archive
     * @secure
     */
    followUpsArchive: <TResponse = unknown, TError = any>(
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/FollowUps/archive`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FollowUps
     * @name FollowUpsRestore
     * @request POST:/linkboard/FollowUps/restore
     * @secure
     */
    followUpsRestore: <TResponse = unknown, TError = any>(
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/FollowUps/restore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FollowUps
     * @name FollowUpsDelete
     * @request POST:/linkboard/FollowUps/delete
     * @secure
     */
    followUpsDelete: <TResponse = unknown, TError = any>(
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/FollowUps/delete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jobs
     * @name JobsGet
     * @request POST:/linkboard/Jobs/search
     * @secure
     */
    jobsGet: <
      TResponse = NuLinkboardAPILogicModelsPaginatedModel1NuLinkboardAPILogicModelsJobModelNuLinkboardAPILogicVersion1000CultureNeutralPublicKeyTokenNull,
      TError = any,
    >(
      data: NuLinkboardAPILogicModelsJobSearchJobSearchInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Jobs/search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jobs
     * @name JobsCount
     * @request POST:/linkboard/Jobs/count
     * @secure
     */
    jobsCount: <TResponse = number[], TError = any>(
      data: NuLinkboardAPILogicModelsJobSearchJobSearchInputModel[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Jobs/count`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jobs
     * @name JobsAddUserInteraction
     * @request POST:/linkboard/Jobs/userinteraction
     * @secure
     */
    jobsAddUserInteraction: <TResponse = unknown, TError = any>(
      data: NuLinkboardAPILogicModelsJobSearchUserInteractionInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Jobs/userinteraction`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jobs
     * @name JobsReportConcern
     * @request POST:/linkboard/Jobs/reportconcern
     * @secure
     */
    jobsReportConcern: <TResponse = unknown, TError = any>(
      data: NuLinkboardAPILogicModelsBreakdownDTOsReportConcernInputModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Jobs/reportconcern`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Jobs
     * @name JobsListPartnerJobsSummary
     * @request GET:/linkboard/Jobs/list
     * @secure
     */
    jobsListPartnerJobsSummary: <
      TResponse = NuLinkboardAPILogicModelsPartnerJobModel[],
      TError = any,
    >(
      query?: {
        /**
         * @format int32
         * @default 100
         */
        count?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Jobs/list`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags JobSettings
     * @name JobSettingsGet
     * @request GET:/linkboard/settings
     * @secure
     */
    jobSettingsGet: <
      TResponse = NuLinkboardAPILogicModelsJobSettingsModel,
      TError = any,
    >(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags JobSettings
     * @name JobSettingsPut
     * @request PUT:/linkboard/settings
     * @secure
     */
    jobSettingsPut: <
      TResponse = NuLinkboardAPILogicModelsJobSettingsModel,
      TError = any,
    >(
      data: NuLinkboardAPILogicModelsJobSettingsModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsGet
     * @request GET:/linkboard/Projects/{id}
     * @secure
     */
    projectsGet: <
      TResponse = NuLinkboardAPILogicModelsProjectModel,
      TError = any,
    >(
      id: string,
      query?: {
        OnlyActive?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Projects/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsUpdate
     * @request PUT:/linkboard/Projects/{id}
     * @secure
     */
    projectsUpdate: <TResponse = unknown, TError = any>(
      id: string,
      data: NuLinkboardAPILogicModelsProjectModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Projects/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsGetAll
     * @request GET:/linkboard/Projects
     * @secure
     */
    projectsGetAll: <
      TResponse = NuLinkboardAPILogicModelsProjectModel[],
      TError = any,
    >(
      query?: {
        status?: LinkboardDomainEnumsProjectStatus;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Projects`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsCreate
     * @request POST:/linkboard/Projects
     * @secure
     */
    projectsCreate: <
      TResponse = NuLinkboardAPILogicModelsProjectModel,
      TError = any,
    >(
      data: NuLinkboardAPILogicModelsProjectModel,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Projects`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsArchive
     * @request POST:/linkboard/Projects/archive
     * @secure
     */
    projectsArchive: <TResponse = unknown, TError = any>(
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Projects/archive`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsRestore
     * @request POST:/linkboard/Projects/restore
     * @secure
     */
    projectsRestore: <TResponse = unknown, TError = any>(
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Projects/restore`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Projects
     * @name ProjectsDelete
     * @request POST:/linkboard/Projects/delete
     * @secure
     */
    projectsDelete: <TResponse = unknown, TError = any>(
      data: string[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Projects/delete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Whoami
     * @name WhoamiGet
     * @request GET:/linkboard/Whoami
     * @secure
     */
    whoamiGet: <TResponse = NuLinkboardAPILogicModelsWhoamiModel, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/linkboard/Whoami`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  apiHealth = {
    /**
     * No description
     *
     * @tags Health
     * @name HealthGet
     * @request GET:/api_health
     * @secure
     */
    healthGet: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/api_health`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
}
